import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./buisnesspdsingleuser.css";
import AutoDriverDetails from "./BuisnessPdDetails/AutoDriverDetails";
import DairyDetails from "./BuisnessPdDetails/DairyDetails";
import AutoGarageDetails from "./BuisnessPdDetails/AutoGarageDetails";
import CableOperatorDetails from "./BuisnessPdDetails/CableOperatorDetails";
import ContractorDetails from "./BuisnessPdDetails/ContractorDetails";
import CateringBuisnessDetails from "./BuisnessPdDetails/CateringBuisnessDetails";
import FlourMillDetails from "./BuisnessPdDetails/FlourMillDetails";
import GarmentsDetails from "./BuisnessPdDetails/GarmentsDetails";
import JuiceCenterDetail from "./BuisnessPdDetails/JuiceCenterDetail";
import GroceryDetail from "./BuisnessPdDetails/GroceryDetail";
import SaloonDetail from "./BuisnessPdDetails/SaloonDetail";
import SweetShopDetail from "./BuisnessPdDetails/SweetShopDetail";
import TeaStallDetails from "./BuisnessPdDetails/TeaStallDetails";
import TentHouseDetails from "./BuisnessPdDetails/TentHouseDetails";
import Vegetabledetail from "./BuisnessPdDetails/Vegetabledetail";
import TailorDetail from "./BuisnessPdDetails/TailorDetail";
import NoDataFound from "./NoDataFound";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import IncomeTable from "./Income/IncomeTable";
import ProfitMarginTable from "./Income/ProfitMarginTable";
import CheckPointTable from "./Income/CheckPointTable";
import ShopTable from "./Income/ShopTable";

function BuisnessPDsingleAllInformation() {
  const location = useLocation();
  const state = location;
  const data = state?.state?.incomes;
  const Profit = state?.state;

  console.log(state.state);

  const [expense, setExpense] = useState([]);
  const [checkPoints, setCheckPoints] = useState([]);
  const [profitMargin, setProfitMargin] = useState([]);
  // const [data , setData] = useState([])

  useEffect(() => {
    const expenses = state?.state?.expenses;
    const checkPoint = state?.state?.checkPoints;
    // const Data = state?.state?.incomes;
    // const ProfitMargin = state?.state?.profitMargin

    // setData(Data)
    setExpense(expenses);
    setCheckPoints(checkPoint);
    // setProfitMargin(ProfitMargin)
  }, []);

  const navigate = useNavigate();

  const handleBackButton = () => {
    navigate(-1);
  };

  // console.log(expense);

  return (
    <div className="main-wrapper">
    <div className="page-wrapper">
    <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            className="m-4"
            onClick={handleBackButton}
          >
            Back
          </Button>
    <div className="col-md-12">
        <div className="card bg-white">
          <div className="card-header">
            <h5 className="card-title">Income View</h5>
          </div>
          <div className="card-body">
            <ul className="nav nav-tabs nav-tabs-top nav-justified">
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  to="#top-justified-tab1"
                  data-bs-toggle="tab"
                >
                  Incomes
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="#top-justified-tab2"
                  data-bs-toggle="tab"
                >
                  Expenses
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="#top-justified-tab3"
                  data-bs-toggle="tab"
                >
                  Profit Margin
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="#top-justified-tab4"
                  data-bs-toggle="tab"
                >
                  Checkpoints
                </Link>
              </li>
            </ul>
            <div className="tab-content">
              <div className="tab-pane show active" id="top-justified-tab1">
              <ShopTable allData={state} />
              </div>
              <div className="tab-pane" id="top-justified-tab2">
              <IncomeTable allExpenses={expense}/>
              </div>
              <div className="tab-pane" id="top-justified-tab3">
              <ProfitMarginTable profitMargin={Profit}/>
              </div>
              <div className="tab-pane" id="top-justified-tab4">
              <CheckPointTable checkPoint={checkPoints}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="content container-fluid">
      
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            className="mb-3"
            onClick={handleBackButton}
          >
            Back
          </Button>
        <div className="row">
          <ShopTable allData={state} />
          <IncomeTable allExpenses={expense}/>
        </div>

        <div className="row">
          <ProfitMarginTable profitMargin={Profit}/>
          <CheckPointTable checkPoint={checkPoints}/>
        </div>
      </div> */}
    </div>
  </div>
  );
}

export default BuisnessPDsingleAllInformation;

{
  /* <div className="col-6 p-3 rounded shadow card flex-fill">
              
              <div className="card-body">
                <div className="static-header">
                  <h5>Expenses</h5>
                  {expense && expense.length > 0 ? (
                    <div className="row">
                      {expense.map((item, index) => (
                        <div
                          key={index}
                          className="col-sm-12 col-md-6 mb-3 mt-3"
                        >
                          <div className="card">
                            <div className="card-body">
                              <h5 className="card-title">{item.name}</h5>
                              <p className="card-text">Amount: {item.amount}</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="text-center text-muted">No data available</p>
                  )}
                </div>
              </div>
            </div> */
}


{/* <div className="page-wrapper">
      <div className="content container-fluid const data = state?.state.incomes;const data = state?.state.incomes;">
       
          <h1 className="text-center">Income View</h1>
          <Button
            type="primary"
            icon={<ArrowLeftOutlined />}
            className="mb-3"
            onClick={handleBackButton}
          >
            Back
          </Button>
          <div className="row mt-4">
            <div className="col-md-6">
              <div className="card p-3 rounded shadow card-body">
                <h5>Incomes & Shop</h5>
                {state?.state?.profileId == "1" ? (
                  <AutoDriverDetails allData={data} />
                ) : state?.state?.profileId == "20" ? (
                  <DairyDetails allData={data} />
                ) : state?.state?.profileId == "2" ? (
                  <AutoGarageDetails allData={data} />
                ) : state?.state?.profileId == "6" ? (
                  <ContractorDetails allData={data} />
                ) : state?.state?.profileId == "4" ? (
                  <CableOperatorDetails allData={data} />
                ) : state?.state?.profileId == "5" ? (
                  <CateringBuisnessDetails allData={data} />
                ) : state?.state?.profileId == "8" ? (
                  <GarmentsDetails allData={data} />
                ) : state?.state?.profileId == "7" ? (
                  <FlourMillDetails allData={data} />
                ) : state?.state?.profileId == "10" ? (
                  <JuiceCenterDetail allData={data} />
                ) : state?.state?.profileId == "11" ? (
                  <GroceryDetail allData={data} />
                ) : state?.state?.profileId == "13" ? (
                  <SaloonDetail allData={data} />
                ) : state?.state?.profileId == "15" ? (
                  <SweetShopDetail allData={data} />
                ) : state?.state?.profileId == "17" ? (
                  <TeaStallDetails allData={data} />
                ) : state?.state?.profileId == "18" ? (
                  <TentHouseDetails allData={data} />
                ) : state?.state?.profileId == "19" ? (
                  <Vegetabledetail allData={data} />
                ) : state?.state?.profileId == "16" ? (
                  <TailorDetail allData={data} />
                ) : (
                  <NoDataFound />
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-12">
                  <IncomeTable allExpenses={expense} />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-12">
                  <ProfitMarginTable profitMargin={profitMargin} />
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-12">
                  <CheckPointTable checkPoint={checkPoints} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}